<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Importer une liste d'utilisateurs</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="row relative">
                            <form id="shipping-form" class="width-100" @submit.prevent="import_adherents">
                                <div id="rootwizard" class="form-wizard col-md-11 ml-auto mr-auto">
                                    <b-tabs pills v-model="tabIndex" nav-wrapper-class="nav-fill">
                                        <b-tab v-bind:disabled="tabIndex == 2" @click="active">
                                            <template slot="title">
                                                <span class="step">1</span>
                                                <span class="title">Sélectionner un fichier</span>
                                            </template>
                                            <div class="form-group">
                                                <label>Choisissez un fichier Excel ou CSV à importer : </label>
                                                <b-form-file ref="fileinput" v-model="file" :state="Boolean(file)" accept=".xlsx, .xls, .csv" placeholder="Choisir votre fichier..."></b-form-file>
                                            </div>
                                            <!-- <div class="form-group">
                                                <label>Séparateur : </label>
                                                <select class="form-control">
                                                    <option value="," selected>Virgule</option>
                                                    <option value=";">Point-virgule</option>
                                                    <option value="\n">Tabulation</option>
                                                    <option value="|">Barre verticale</option>
                                                    <option value=":">Double point</option>
                                                </select>
                                            </div> -->
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox" v-model="first_column_header" id="first_header">
                                                <label class="form-check-label" for="first_header">
                                                    Utiliser la première ligne comme entête de fichier
                                                </label>
                                            </div>
                                        </b-tab>
                                        <b-tab v-bind:disabled="file == '' || tabIndex == 2  || options_obligatory == '' ">
                                            <template slot="title">
                                                <span class="step">2</span>
                                                <span class="title">Sélectionner et vérifier les colonnes</span>
                                            </template>
                                            <p class="text-center font-weight-bold mb-5">Veuillez associer les colonnes de votre fichier aux données attendues</p>
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Code<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.code" :options="options_obligatory" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Titre<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.title" :options="options_obligatory" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Nom<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.lastname" :options="options_obligatory" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Prénom<span class="text-danger"></span> : </label>
                                                        <b-form-select v-model="columns.firstname" :options="options_obligatory" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                                <div class="offset-md-1 col-md-6">
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Email<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.email" :options="options" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Numéro télephone fixe : </label>
                                                        <b-form-select v-model="columns.tel" :options="options" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Numéro téléphone mobile<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.mobile" :options="options" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab v-bind:disabled="!import_success">
                                            <template slot="title">
                                                <span class="step">3</span>
                                                <span class="title">Confirmation</span>
                                            </template>
                                            <div class="col-md-6 mr-auto ml-auto">
                                                <div class="text-center">
                                                    <h2>Félicitation!</h2>
                                                    <p>Votre liste d'utilisateurs à été bien importée</p>
                                                    <router-link to="/adherents/index" class="btn btn-info btn-inverse btn-lg">
                                                        Voir tous les utilisateurs
                                                    </router-link>
                                                </div>
                                            </div>
                                        </b-tab>
                                    </b-tabs>

                                    <div id="bar" class="progress progress-info" style="width: 65%">
                                        <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
                                    </div>

                                    <div class="mt-2">
                                        <button type="button" class="btn btn-default button-previous btn-rounded" @click="clear(tabIndex--)" v-show="tabIndex == 1">Précédent</button>
                                        <button type="button" class="btn btn-primary button-next pull-right btn-rounded" @click="next" v-bind:disabled="file == ''" v-show="tabIndex == 0">Suivant</button>
                                        <button type="submit"
                                                class="btn btn-primary button-next pull-right btn-rounded"
                                                v-show="tabIndex == 1">Importer</button>
                                        <button type="button"
                                                @click="cancel_step2"
                                                class="btn btn-danger pull-right btn-rounded"
                                                v-show="tabIndex == 1">Annuler</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import api from "../../config/_api";
    import XLSX from "xlsx";

    export default {
        name: "Import",
        data () {
            return {
                tabIndex: 0,
                file: null,
                startData: 1,
                first_column_header: true,
                data: {},
                columns: {
                    code: null,
                    title: null,
                    lastname: null,
                    firstname : null,
                    email: null,
                    tel: null,
                    mobile: null
                },
                options_obligatory: [],
                options: [],
                import_success: false
            }
        },
        methods: {

            import_adherents() {

                let data = {
                    data: this.data,
                    columns: this.columns,
                    first_column_header: this.first_column_header
                };

                var first_line_to_check = data.first_column_header ? 1 : 0;
                // eslint-disable-next-line
                var  interdit = /[&~#'{[|`\\^@)\]°}=+$~"^¨«»³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;.,?<>]/ig;
                var normally_checked_collumns=[data.columns.code,data.columns.title,data.columns.lastname,data.columns.firstname]
                var data_to_send = [];
                        
                for( var n = first_line_to_check; n < data.data.length; n++){
                    var has_data = false;
                    for(var c = 0; c<data.data[n].length;c++){
                        if(data.data[n][c]!=undefined || data.data[n][c]!=null){
                            has_data = true;
                            break;
                        }
                    }
                    if(!has_data) {
                        continue;
                    }
                    data_to_send.push(data.data[n]);
                    if (data.data[n][data.columns.code] == undefined ){
                        alert ("Attention, le fichier n'est pas conforme (code l"+ (n+1) +")");
                        return  window.location.reload();
                    }
                    if (data.data[n][data.columns.lastname] == undefined ){
                        alert ("Attention, le fichier n'est pas conforme (nom l"+ (n+1) +")");
                        return  window.location.reload();
                    }
                    if (data.data[n][data.columns.title] == undefined ){
                        data.data[n][data.columns.title] = "";
                       // alert ("Attention, le fichier n'est pas conforme (titre l"+ (n+1) +")");
                       // return  window.location.reload();
                    }
                    //TODO refaire cette partie
                    var y = [data.data[n]];
                    var h="";
                    for(var s = 0; s <y.length; s++){
                        for(var p = 0; p <normally_checked_collumns.length; p++){
                            h =  y[s][normally_checked_collumns[p]];
                            if((h != undefined) && (h != "")) {
                                //var chaine = h.trim();replace(/^\s+|\s+$/gm,'') ;
                                var chaine="";
                                if((typeof h) =="number"){
                                    chaine = h.toString().replace(/^\s+|\s+$/gm,'') ;
                                }
                                else{
                                    chaine = h.replace(/^\s+|\s+$/gm,'') ;
                                }
                                if((chaine.length > 255) || 
                                    interdit.test(chaine) || 
                                    (chaine == "") 
                                ){
                                    alert ("Attention, le fichier n'est pas conforme (l"+ (n+1)+")");
                                    return  window.location.reload();
                                }
                            }
                        }
                        var mail =  y[s][data.columns.email];
                        var fixe =  y[s][data.columns.tel];
                        var mobile = y[s][data.columns.mobile];
                        if(mail != undefined ) {
                            var chaine_mail = mail.trim();
                            // eslint-disable-next-line
                            var regex = /^(([^<>()[\]\\.,*+;:°}=+$~"^¨«»³€†%©®ª()ß*'µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;\s@"]+(\.[^<>()[\]\\.,;°}=+$~"^¨«»'³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;:*+\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                            if (!chaine_mail.match(regex)){
                                alert ("Attention, adresse mail non conforme ligne "+(n+1));
                                return  window.location.reload();
                            }  
                        }
                        else{
                            alert ("Attention, adresse mail manquante (l"+ (n+1) +")");
                            return  window.location.reload();
                        }
                        //TODO utiliser une méthode pour tester les numéros de télphone pour ne pas avoir de doublons dans le code
                        if(fixe != undefined ) {
                            var fixeVerified=this.verifyMobile(fixe);
                            if(fixe[0]=='+'){
                                if((fixeVerified.length != 12) || !fixeVerified.substring(1).match(/^([0-9]+)$/)){
                                    alert ("Attention, numéro fixe non conforme ligne "+(n+1));
                                    return window.location.reload();
                                }
                            }
                            else if(((fixeVerified.length != 10) && (fixeVerified.length != 13)) || !fixeVerified.match(/^([0-9]+)$/)){
                                alert ("Attention, numéro fixe non conforme ligne "+(n+1));
                                return window.location.reload();
                            }
                            data.data[n][data.columns.tel] = fixeVerified;
                        }
                        if(mobile != undefined ) {
                            var mobileVerified=this.verifyMobile(mobile);
                            if(mobile[0]=='+'){
                                
                                if((mobileVerified.length != 12) || !mobileVerified.substring(1).match(/^([0-9]+)$/)){

                                    alert ("Attention, numéro mobile non conforme ligne "+(n+1));
                                    return window.location.reload();
                                }
                            }
                            else if(((mobileVerified.length != 10) && (mobileVerified.length != 13)) || !mobileVerified.match(/^([0-9]+)$/)){
                                alert ("Attention, numéro mobile non conforme ligne "+(n+1));
                                return window.location.reload();
                            }
                            data.data[n][data.columns.mobile] = mobileVerified;
                        }
                    }
                    data_to_send.push(data.data[n]);
                }

                var self = this;
                data.data = data_to_send;

                this.axios({url: api.url + 'adherents/import?structure_id=' + this.$store.getters.structure_id, data: data, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            self.import_success = true;
                            setTimeout(function () {
                                self.tabIndex++;
                            }, 50);
                        }
                    })
                   /* .catch(err => {
                        console.log(err);
                    });*/
            },
            cancel_step2() {
                this.columns = {
                    code: null,
                    title: null,
                    lastname: null,
                    firstname: null,
                    email: null,
                    tel: null,
                    mobile: null
                };
            },
            verifyMobile(mobile){
                    if((typeof mobile) =="number"){
                        mobile = mobile.toString();
                        if(mobile.length == 9){
                            mobile = "0"+mobile;
                        }
                    }
                    mobile=mobile.replace(/\s|\.|,|-|_/g,'');
                    mobile=mobile.trim().replace(/ /g,'');
                    return mobile;
            },
            active(){
               this.options_obligatory ='';
               },
            clear(){
                this.$refs.fileinput.reset();
                this.options_obligatory ='';
            },
            next(){
                var url = window.URL.createObjectURL(this.file);
                var self = this;
                self.columns = {
                    code: null,
                    title: null,
                    lastname: null,
                    firstname : null,
                    email: null,
                    tel: null,
                    mobile: null
                };
                self.options_obligatory = [{ value: null, text: 'Veuillez sélectionner une colonne' }];
                self.options = [{ value: null, text: 'Veuillez sélectionner une colonne' }, {value: -1, text: 'Aucune colonne correspondante'}];
                this.axios(url, {responseType:'arraybuffer'})
                /*.catch(function(err) {
                    console.log("Bug à la récupération du fichier");
                })*/.then(function(res) {
                    var data = new Uint8Array(res.data);
                    var workbook = XLSX.read(data, {type:"array"});
                    return workbook;
                })/*.catch(function(err) {
                })*/.then(function(workbook) {
                    self.data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {header:1, raw:true});
                      
                    var first_line_to_check = 0;
                    if(document.getElementById('first_header').checked){
                        first_line_to_check = 1;
                    }

                    // eslint-disable-next-line
                    var interdit = /[&~#'{[|`\\^)\]°}=$~"^¨«»³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;,?<>]/ig;

                    for(var j = 0; j < self.data[0].length; j++) {
                        var text = "Colonne n°" + j + " : ";
                        for (var t = first_line_to_check; t <  self.data.length; t++) {
                            if(interdit.test(self.data[t][j])){
                                alert ("Attention, le fichier contient des caractères interdits\n/[&~#'{[|`\\^)]°}=$~\"^¨«»³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;,?<>] ligne "+t+" colonne "+j + " data "+self.data[t][j]);
                                return  window.location.reload();
                            }
                            text = text + (self.data[t][j] != undefined && self.data[t][j] != "" ? self.data[t][j] : "indéfini") + (t != (self.data.length-1) ? ", " : "");
                            if(self.data[t][j] == undefined){
                                self.data[t][j] = null;
                            }
                        }
                        var option = {
                            value : j,
                            text: text
                        };
                        self.options_obligatory.push(option);
                        self.options.push(option);
                    }
                    self.tabIndex++;
                });
            }
        }
    }
</script>